export default {
  SET_LANG(state, lang) {
    state.language = lang;
  }
};
